import AbstractType from './AbstractType';

export const searchTypes = {
  AbstractType,
};
